import { CURRENCY_SYMBOL, DEFAULT_CURRENCY } from "../constants/common";
import { numberForamting } from "./globalUtils";
import { RECIPIENT_DOC_BAND_TYPE_MAP } from "../constants/document";

export const getFieldValue = (field, currency) => {
  if (!currency) {
    currency = DEFAULT_CURRENCY;
  }
  const { value: fieldValue } = field;
  if (!fieldValue) {
    return "";
  }

  let value;
  if (field.type === "PERIOD") {
    const { periodValue, periodUom } = fieldValue;
    if (periodValue && periodUom) {
      value = `${periodValue || ""} ${periodUom || ""}`;
    }
  } else if (field.type === "ADDRESS") {
    const { addressLineOne, addressLineTwo, city, state, zip, country } =
      fieldValue;
    if (addressLineOne || addressLineTwo || city || state || country) {
      value = `${addressLineOne ? `${addressLineOne},` : ""}${
        addressLineTwo ? `${addressLineTwo},` : ""
      }${city ? `${city},` : ""}${state ? `${state},` : ""}${
        zip ? `- ${zip},` : ""
      }${country ? `(${country})` : ""}`;
    } else {
      value = null;
    }
  } else if (field.type === "PERSON_NAME") {
    const { firstName, lastName } = fieldValue;
    value = firstName || lastName ? `${firstName} ${lastName}` : "";
  } else if (field.type === "AMOUNT") {
    let currencyInfo = currency;

    if (
      Object.keys(fieldValue).length !== 0 &&
      fieldValue.currency &&
      fieldValue.currency !== "PRICEBOOK"
    ) {
      currencyInfo = fieldValue.currency;
    }

    const symbol = CURRENCY_SYMBOL[currencyInfo];
    if (fieldValue.val) {
      value = numberForamting(fieldValue.val, symbol);
    } else {
      value = null;
    }
  } else if (field.type === "PERCENT") {
    if (fieldValue !== "") {
      value = numberForamting(fieldValue, "", "%");
    } else {
      value = fieldValue;
    }
  } else if (field.type === "RATE") {
    const { rateValue, rateUom } = fieldValue;
    if (rateValue === "" || rateUom === "") {
      value = "";
    } else {
      value = `${rateValue} ${rateUom}`;
    }
  } else if (field.type === "CHECKBOX") {
    value = Array.isArray(fieldValue) ? fieldValue.join(", ") : "";
  } else if (field.type === "DATE") {
    value = fieldValue ? fieldValue.val : "";
  } else {
    value = fieldValue;
  }
  return value;
};

// Function is used to find whether the document is in fillable stage or not
export const isSharedFormDocumentFillable = (
  docStage,
  acceptingStates,
  recipientType,
) => {
  let isFillable = false;
  let bandType = "";
  const stageMap = docStage ? RECIPIENT_DOC_BAND_TYPE_MAP[docStage] : null;
  if (stageMap) {
    if (acceptingStates) {
      bandType = stageMap[acceptingStates];
    } else if (recipientType) {
      bandType = stageMap[recipientType];
    }
  }
  if (
    bandType === "FILL_AND_ESIGN" ||
    bandType === "ESIGN" ||
    bandType === "ACCEPTOR"
  ) {
    if (docStage === "SENT_FOR_FILLING" && recipientType === "FILLER") {
      isFillable = true;
    }
  }
  return isFillable;
};
